import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function ChairmanMessage() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Chairman’s Message</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Chairman’s Message</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Chairman’s Message</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 PrincipalDesk principal-message">
                            <img src="https://webapi.entab.info/api/image/SMNSB/public/images/chairman.jpg" alt="Principal Photo" className="img-fluid" />
                            <p>A warm welcome to you all! I hope you all had a refreshing and fruitful vacation. Every new school year is a fresh beginning full of promises and possibilities. It is a chance to leave behind what didn't work and embrace the new opportunities that lie ahead. Whether you are stepping onto the campus for the first time or returning after your vacation, be proud that you are part of a vibrant MGM community, a brand in itself.<br />

                                School days are the happiest days of our lives. School is like a second home for every student, where your teachers and friends are your family. Respect your parents, teachers, and elders, and foster good and meaningful relationships with your schoolmates. Friendships developed at school not only fulfill the purpose of having fun but also promote a strong sense of positivity and mental well-being, encouraging learning and interpersonal skills. At school, we cultivate strong values, which are a powerful instrument for social change and human progress. Prioritize values like love, honesty, loyalty, mutual respect, and empathy in your lives.
                            </p>
                            <p><b>H.G. Alexios Mar Eusebius Metropolitan <br />
                                Diocese of Calcutta</b></p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default ChairmanMessage